
import {urlConfig} from '@/api/urlConfig';
import {promptMessage,fetch} from '@/api/dataHandling';
import {getken} from '@/api/getToken';
import {Loadmore,Spinner } from "mint-ui";
import Countdown from 'vux/src/components/countdown/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Icon from 'vux/src/components/icon/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import { MessageBox } from 'mint-ui';
export default {
data(){
return {
lookArry:[],
bigTabIndex:1,
checkPerson:'',
opcRegId:'',
personInfoId:'',
opcRegId:'',
checkInfo:'',
opdinfo:{},
personInfo:{},
prescnos:[],
labResults:[],
examResults:[],
submitdisabled:true,
labLoadmoreShow: true,
labLoadmoreTxt:'加载中····',
labAllLoaded:false,
pageSize:10,
labPageNumber:1,
labResultTotal:0,
examLoadmoreShow: true,
examLoadmoreTxt:'加载中····',
examAllLoaded:false,
examPageNumber:1,
examResultTotal:0,

}
},


methods: {

HeaderswitchTab(index){
console.log("index="+index)
this.bigTabIndex = index;
if(this.bigTabIndex=='2'){
this.seachLabInfos();
}
if(this.bigTabIndex=='3'){
this.seachExamInfos();
}


},











checkSuccess(){
MessageBox.confirm('确定审核通过?').then(action => {
fetch('post',urlConfig.drugOrdersCheck,{"orderNo":this.orderNo,"orderStatus":'4',"checkPerson":this.checkPerson}).then(response => {
console.log("responsecheck1="+JSON.stringify(response))

MessageBox.alert('操作成功', '提示');
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
console.log(error);
})
}).catch(err=>{console.log(err)});

},
checkFail(){
MessageBox.prompt('请输入审核不通过原因').then(({ value, action }) => {
fetch('post',urlConfig.drugOrdersCheck,{"orderNo":this.orderNo,"orderStatus":'3',"orderMsg":value,"checkPerson":this.checkPerson}).then(response => {
MessageBox.alert('操作成功', '提示');


this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
console.log(error);
})
}).catch(err=>{console.log(err)});
},

handleLabBottomChange(status) {

if(status =='loading'){
this.labLoadmoreTxt = '加载中';
}
},
loadLabBottom() {

setTimeout(() => {
this.labPageNumber++;
this.seachLabInfos();
}, 1500);
},

seachLabInfos(){
this.$store.commit('updateLoadingStatus',{isLoading:true});

let labPersonInfoId=this.$route.query.personInfoId;
fetch('post',urlConfig.patientLabInfosGet+"?personInfoId="+labPersonInfoId+"&pageNumber="+this.labPageNumber+"&pageSize="+this.pageSize).then(response => {
this.labResultTotal=response.total;
let labRows=response.rows;
labRows.forEach(element => {
try{
if(element.highLow!=null&&element.highLow!=""){
let highlow=String(element.highLow);
highlow=highlow.replace(/H/g, "↑")
highlow=highlow.replace("L", "↓")
element.highLow=highlow
}
}
catch(error){
alert(error)
}

this.labResults.push(element);
});

if(this.labResults.length == 0){
this.labLoadmoreShow = false;
this.labLoadmoreTxt = '暂无数据';
this.labAllLoaded = true;
}else if(this.labResults.length === this.total){
this.labLoadmoreShow = false;
this.labLoadmoreTxt = '已经到底了';
this.labAllLoaded = true;
}else{
this.labLoadmoreShow = false;
this.labLoadmoreTxt = '上拉加载更多';
this.labAllLoaded = false;
}

/**this.resultOption.forEach(element=>{

})*/

this.$refs.labLoadmore.onBottomLoaded();

this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
},
handleExamBottomChange(status) {

if(status =='loading'){
this.examLoadmoreTxt = '加载中';
}
},
loadExamBottom() {

setTimeout(() => {
this.examPageNumber++;
this.seachExamInfos();
}, 1500);
},

seachExamInfos(){
this.$store.commit('updateLoadingStatus',{isLoading:true});

let examPersonInfoId=this.$route.query.personInfoId;
fetch('post',urlConfig.patientExamInfosGet+"?personInfoId="+examPersonInfoId+"&pageNumber="+this.examPageNumber+"&pageSize="+this.pageSize).then(response => {
console.log("responseexam="+JSON.stringify(response));
this.examResultTotal=response.total;
let examRows=response.rows;
examRows.forEach(element => {
element.reportDate=element.reportDate.substring(0,10);
this.examResults.push(element);
});

if(this.examResults.length == 0){
this.examLoadmoreShow = false;
this.examLoadmoreTxt = '暂无数据';
this.examAllLoaded = true;
}else if(this.examResults.length === this.total){
this.examLoadmoreShow = false;
this.examLoadmoreTxt = '已经到底了';
this.examAllLoaded = true;
}else{
this.examLoadmoreShow = false;
this.examLoadmoreTxt = '上拉加载更多';
this.examAllLoaded = false;
}

/**this.resultOption.forEach(element=>{

})*/

this.$refs.examLoadmore.onBottomLoaded();

this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
},
showExamDetail(message){
MessageBox('检查详情', message);
},
getData(){

this.opcRegId = this.$route.query.opcRegId;
this.personInfoId = this.$route.query.personInfoId;
this.orderNo = this.$route.query.orderNo;
this.checkPerson=this.$route.query.checkPerson;
fetch('post',urlConfig.opdInquiryByOpcRegIdGet+"?opcRegId="+this.opcRegId+"&orderNo="+this.orderNo).then(response => {
console.log("response1="+JSON.stringify(response))
this.opdinfo=response;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
console.log(error);
})

fetch('post',urlConfig.preReviewDrugDataGet+"?orderNo="+this.orderNo).then(response => {
console.log("response2="+JSON.stringify(response))
this.prescnos=response
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
console.log(error);
})


fetch('post',urlConfig.patientBasicInfosGet+"?personInfoId="+this.personInfoId).then(response => {
console.log("response4="+JSON.stringify(response))
this.personInfo=response
fetch('get',urlConfig.getauditrecord + this.personInfo.idCard).then(response => {
this.lookArry = response;
for(let i =0;i< this.lookArry.length;i++){
this.lookArry[i].CREATED_DATE = this.timestampToTime(this.lookArry[i].CREATED_DATE);
}
}).catch(error => {


})
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
console.log(error);
})

fetch('post',urlConfig.queryCheckInfosByOrdersNo+"?orderNo="+this.orderNo).then(response => {
console.log("response4="+JSON.stringify(response))
this.checkInfo=response
if( this.checkInfo!=null){
if(this.checkInfo.ORDERSTATUS=="1"){
this.checkInfo.ORDERSTATUS="待审核";
}else if(this.checkInfo.ORDERSTATUS=="2"){
this.checkInfo.ORDERSTATUS="审核完成";
}else if(this.checkInfo.ORDERSTATUS=="3"){
this.checkInfo.ORDERSTATUS="审核不通过";
}else if(this.checkInfo.ORDERSTATUS=="4"){
this.checkInfo.ORDERSTATUS="签名";
}else if(this.checkInfo.ORDERSTATUS=="5"){
this.checkInfo.ORDERSTATUS="签名失败";
}else if(this.checkInfo.ORDERSTATUS=="6"){
this.checkInfo.ORDERSTATUS="审核完成";
}

}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
console.log(error);
})



}
},
components: {
"mt-loadmore": Loadmore, Countdown,Toast,XDialog,XInput,Cell, Group, XHeader,XButton,Checker, CheckerItem,Icon,CellBox,XTable, Tab, TabItem,LoadMore,Flexbox, FlexboxItem,
},
mounted(){

getken(this.getData);










}
}



// WEBPACK FOOTER //
// ./src/project/prescnoVerifyProject/prescnoVerify.vue